export default defineNuxtPlugin((nuxtApp) => {
  const i18n = nuxtApp.vueApp.config.globalProperties.$i18n;
  const useFetchWithAuth = async (url, options = {}) => {
    const token = useCookie('token'); // Get auth token
    console.log(token)
    const headers = {
      ...options.headers,
      Authorization: token.value ? `Bearer ${token.value}` : '',
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'locale': i18n.locale, // Pass locale dynamically
    };

    return useFetch(url, {
      server: false, // Ensure request is client-side
      ...options,
      headers,
    });
  };

  // Provide globally
  return {
    provide: {
      useFetchWithAuth,
    },
  };
});
